'use client';

import { useEffect } from 'react';

import {
    logSentryError,
    SentryPdpMiniPdpAutoshipErrors as SentryErrors,
    useCustomerAutoshipSubscriptions,
    useDecisions,
} from '@libs/common-next';
import type { Product } from '@libs/common-types';

import { getAutoshipDiscountMessages, isProductAvailableForAutoship } from '../../product-details';
import { isCustomerFirstAutoshipEligible } from '../lib';

export function useMiniPdpAutoship(product: Product) {
    const isEnabled = useDecisions('as_mini_pdp');
    const { autoshipData, isReady, isLoading, isFetching, isError, error } = useCustomerAutoshipSubscriptions();

    const isFirstAutoshipEligible = isCustomerFirstAutoshipEligible(autoshipData);
    const hasNoSubscriptionData = isError && !autoshipData;

    useEffect(() => {
        if (isEnabled && isError) {
            logSentryError(error, SentryErrors.MiniPdpAutoship.FetchSubscriptionsFailed);
        }
    }, [error, isEnabled, isError]);

    return {
        shouldRender: isEnabled && isProductAvailableForAutoship(product) && !hasNoSubscriptionData,
        isLoading: isLoading || (isFetching && isFirstAutoshipEligible),
        isDisabled: !isReady,
        messages: getAutoshipDiscountMessages({
            isFirstAutoshipEligible,
            discountDisplay: product.autoship.discountDisplay,
        }),
    };
}
